export default __webpack_public_path__ + "static/media/scanner.5d300019.svg";